module.exports = fs;


//////////////////
// WEBPACK FOOTER
// external "fs"
// module id = 1180
// module chunks = 65